import { AISummary } from "@/components/ai/AISummary.tsx";
import { Comment } from "@/components/comments/Comment.tsx";
import { CommentsCount } from "@/components/comments/CommentsCount.tsx";
import { FormAggregatedResultElementProps } from "@/components/form-result/aggregated-result/components/types.ts";
import { Box, Stack, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export const FormAggregatedResultOpenAnswerElement = ({
  element,
  result,
  showDetailModalCallback,
  hideAISummary,
  showMore,
}: FormAggregatedResultElementProps) => {
  const { t } = useTranslation();

  const openAnswerSettings = element.open_answer_settings;
  if (!openAnswerSettings) return null;

  return (
    <>
      <Box
        className={twMerge("flex-1 ", showDetailModalCallback ? "cursor-pointer" : undefined)}
        onClick={showDetailModalCallback ? () => showDetailModalCallback(element) : undefined}
      >
        <Title
          header={openAnswerSettings.title || t("surveys:question_type_open_answer")}
          size={"sm"}
          className={twMerge(
            "wrap-break-word overflow-hidden",
            openAnswerSettings.title ? "" : "text-secondary"
          )}
          required={openAnswerSettings.is_required}
        />
        {result && result.open_answer_data && (
          <>
            {result.open_answer_data.ai_summary && !hideAISummary ? (
              <Box className={"py-4"}>
                <AISummary
                  ai_summary={result.open_answer_data.ai_summary}
                  caption={t("surveys:ai_summary_open_answer_description")}
                  showMore={showMore}
                  showAllResponsesButton={true}
                />
              </Box>
            ) : (
              <>
                {result &&
                  result.open_answer_data &&
                  result.open_answer_data.comments_count > 0 && (
                    <Box className={"py-4"}>
                      <CommentsCount
                        totalComments={result.open_answer_data.comments_count}
                        commentersPreview={result.open_answer_data.commenters_preview || []}
                      />
                    </Box>
                  )}
                {result &&
                  result.open_answer_data &&
                  result.open_answer_data.answer_previews.length > 0 && (
                    <Stack gap={"sm"} className={"py-4"}>
                      {result.open_answer_data.answer_previews.map((answer, index) => (
                        <Comment
                          text={answer.answer_text}
                          employee={answer.employee}
                          key={`${index}`}
                        />
                      ))}
                    </Stack>
                  )}
              </>
            )}
          </>
        )}
      </Box>
    </>
  );
};
